export const integrations = {
  TITLE: "Integrations",
  TABS: {
    EXACT_ONLINE: "Exact Online",
    PEPPOL: "Peppol",
    ELITE: "Elite",
  },
  EXACT_ONLINE: {
    INTEGRATION_TITLE: "Exact Online integration",
    INTEGRATION_CONNECT_DESCRIPTION: "Connect the Fordesk application with your Exact Online account",
    INTEGRATION_CONNECTED_DESCRIPTION: "The Fordesk application is connected with your Exact Online account",
    DELETE_INTEGRATION: "Are you sure you want to remove the Fordesk integration with your Exact Online account?",
    DELETE_INTEGRATION_TITLE: "Removing Exact Online integration",
  },
  PEPPOL: {
    ID: "Peppol ID",
    INTEGRATION_TITLE: "Peppol integration",
    INTEGRATION_CONNECT_DESCRIPTION: "Connect the Fordesk application with Peppol",
    INTEGRATION_CONNECTED_DESCRIPTION: "The Fordesk application is connected with Peppol",
    DELETE_INTEGRATION: "Are you sure you want to remove the Fordesk integration with Peppol?",
    DELETE_INTEGRATION_TITLE: "Removing Peppol integration",
    CREATE_INTEGRATION_TITLE: "Creating Peppol integration",
    CREATE_INTEGRATION_DESCRIPTION: "The data you provide is used to create a record in the Peppol system. Make sure the information is correct",
    APPROVE_INTEGRATION_CREATION_TITLE: "Approve Peppol Integration creation",
    APPROVE_INTEGRATION_CREATION: "Please confirm that the information you entered is correct",
    NEW_PEPPOL_ID_CREATE_CONFIRMATION_TITLE: "New Peppol ID will be registered in the Peppol network",
    NEW_PEPPOL_ID_CREATE_CONFIRMATION: "It seems that your Peppol ID has not yet been created in the Peppol network, so it will be registered. Do you want to proceed?",
    PRIMARY_PEPPOL_SCHEME: "Primary Peppol scheme",
    SECONDARY_PEPPOL_SCHEME: "Secondary Peppol scheme",
    PRIMARY_PEPPOL_ID_OR_VAT_NUMBER: "Primary Peppol ID / VAT nr.",
    SECONDARY_PEPPOL_ID_OR_VAT_NUMBER: "Secondary Peppol ID / VAT nr.",
    EXCHANGE_CAPABILITY: "Exchange capability",
    ACTS_AS_SENDER_ONLY: "Acts as Sender only",
    ACTS_AS_RECEIVER_ONLY: "Acts as Receiver only",
    ACTS_AS_SENDER_RECEIVER: "Acts as Sender/Receiver",
  },
  ELITE: {
    SETTINGS_TITLE: "Elite integration settings",
    SETTINGS_DESCRIPTION: "Configure the values used when processing customs declarations received from Elite.",
    B1_STATISTICAL_VALUE_DEDUCTION_PER_METRIC_TON: "B1 statistical value deduction per metric ton",
    B1_STATISTICAL_VALUE_DEDUCTION_HELP: "This positive amount is deducted from the commercial value for each metric ton. It is applied in the invoice currency when the Elite B1 customs declaration is sent.",
  },
  CONNECTED_STATE: "Connected",
  USER: "User",
  NO_CONFIGURABLE_INTEGRATIONS: "No configurable integrations requiring your attention",
  OPEN_AUTH_POPUP_ERROR: "Unable to open authentication window. Please allow popups for this site",
}
